import { formatMoney as _formatMoney } from './util';


// ! This function receives product data
// ! While some product do have only product.variant
// ! Rest are an array of variants
// ! Due to this reason, its giving the undefined error

// product {
//     variant: undefined,
//     variants: Array(4)
//     [0: {id: 40936771911773, title: 'Soft White / XS', option1: 'Soft White', option2: 'XS', option3: null, …}
//     1: {id: 40936771944541, title: 'Soft White / S', option1: 'Soft White', option2: 'S', option3: null, …}
//     2: {id: 40936771977309, title: 'Soft White / M', option1: 'Soft White', option2: 'M', option3: null, …}
//     3: {id: 40936772010077, title: 'Soft White / L', option1: 'Soft White', option2: 'L', option3: null, …}]
// }

export default function trackQuickShopClick (product) {
    var event = {
        event: 'quickshop-click',
        ecommerce: {
            currencyCode: window.Shopify.currency.active || undefined,
            detail: {
                products: [
                    {
                        name: product.title,
                        id: product.id.toString(),
                        price: _formatMoney(product.price),
                        brand: product.vendor,
                        category: product.type || undefined,
                        variant: product.variant?.title.toString(),
                        // product 'price type'
                        dimension15: (
                            product.variant?.compare_at_price &&
                            (product.variant?.compare_at_price > product.variant?.price)
                        )
                            ? 'sale'
                            : 'msrp',
                        // msrp
                        metric2: _formatMoney(product.variant?.compare_at_price || product.variant?.price),
                    },
                ],
            },
        },
    };

    window.dataLayer.push(event);
}